import {
  signalStore,
  withHooks,
  withMethods,
  withState,
  patchState,
} from '@ngrx/signals';
import { ActiveUserStore } from '../user/active-user.state';
import { BaseState, withCrudOperations } from '../crud.state';
import { Tracking } from '../../models/tracking';
import { TrackingApiService } from '../../services/tracking/tracking-api.service';
import { effect, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export type TrackingState = BaseState<Tracking>;

export const initialState: TrackingState = {
  items: {},
  loading: false,
  initialized: false,
  itemsLoaded: false,
  selectedId: '',
  selection: [],
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Tracking',
  entityLabel: 'Aktivitäts-Log',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const TrackingStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Tracking>(TrackingApiService),
  withMethods((store, http = inject(HttpClient)) => ({
    loadFiltered(queryFilters: any) {
      patchState(store, { loading: true });
      const params: string[] = [];
      Object.keys(queryFilters).forEach(key => {
        if (
          queryFilters[key] !== null &&
          queryFilters[key] !== undefined &&
          queryFilters[key] !== ''
        ) {
          params.push(`${key}=${encodeURIComponent(queryFilters[key])}`);
        }
      });
      const queryString = params.length > 0 ? `?${params.join('&')}` : '';
      return http
        .get<
          Tracking[]
        >(`${environment.apiUrl}/api/tracking/findMany${queryString}`)
        .subscribe({
          next: items => {
            const itemsMap = items.reduce(
              (acc, item) => {
                if (item._id) acc[item._id] = item;
                return acc;
              },
              {} as { [key: string]: Tracking }
            );
            patchState(store, {
              items: itemsMap,
              loading: false,
              initialized: true,
              itemsLoaded: true,
            });
          },
          error: err => {
            console.error(err);
            patchState(store, { loading: false });
          },
        });
    },
  })),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // See category.state.ts for why this watches commune reactively
      // instead of firing once at construction time.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
  })
);
export type TrackingStore = InstanceType<typeof TrackingStore>;
